import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var CheckBoxOutlineBlank = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5v14H5V5h14m2-2H3v18h18V3z"
  }));
});
CheckBoxOutlineBlank.displayName = 'CheckBoxOutlineBlank';
export var CheckBoxOutlineBlankDimensions = {
  height: 24,
  width: 24
};